/** Suffixe UI pour le pilote lié au compte connecté. */
export const OWN_DRIVER_SUFFIX = ' (vous)';

export function isOwnDriver(
  driverId: number | null | undefined,
  currentUserDriverId: number | null | undefined
): boolean {
  return (
    driverId != null &&
    currentUserDriverId != null &&
    Number.isFinite(driverId) &&
    Number.isFinite(currentUserDriverId) &&
    driverId === currentUserDriverId
  );
}

/**
 * Libellé d’affichage d’un pilote : ajoute « (vous) » si c’est le pilote du compte.
 * Idempotent (ne double pas le suffixe). N’altère pas les données persistées.
 */
export function formatDriverDisplayName(
  baseName: string,
  driverId: number | null | undefined,
  currentUserDriverId: number | null | undefined,
  suffix: string = OWN_DRIVER_SUFFIX
): string {
  const name = baseName.trim();
  if (!name) return name;
  if (!isOwnDriver(driverId, currentUserDriverId)) return name;
  if (name.endsWith(suffix) || name.endsWith(suffix.trim())) return name;
  return `${name}${suffix}`;
}

/** Prénom + nom, avec suffixe « (vous) » si besoin. */
export function formatDriverFullName(
  firstName: string,
  lastName: string,
  driverId: number | null | undefined,
  currentUserDriverId: number | null | undefined,
  suffix: string = OWN_DRIVER_SUFFIX
): string {
  return formatDriverDisplayName(
    `${firstName} ${lastName}`.trim(),
    driverId,
    currentUserDriverId,
    suffix
  );
}

/** Retire un éventuel suffixe « (vous) » avant initiales / nom court. */
export function stripOwnDriverSuffix(name: string, suffix: string = OWN_DRIVER_SUFFIX): string {
  const trimmed = name.trim();
  if (trimmed.endsWith(suffix)) return trimmed.slice(0, -suffix.length).trimEnd();
  const bare = suffix.trim();
  if (bare && trimmed.endsWith(bare)) return trimmed.slice(0, -bare.length).trimEnd();
  return trimmed;
}
